const initialState = {
  liquid: null,
  secure: true,
  loading: false,
  addressActive: false,
  addressUpdated: false,
  address: {
    active: false,
    address1: "",
    city: "",
    formattedAddress: "",
    latitude: 40.698359,
    longitude: -73.98643779999999,
    placeId: "ChIJGz_5rjVawokRz7nKEpkWXnM",
    state: "NY",
    zipCode: "11201",
    apt: '',
  },
  newAddress: {},
  cartId: null,
}

export default initialState
